import './stories-module-slide.scss';
